import { Redirect, useLocalSearchParams } from "expo-router";

import { staffPath } from "../../../src/lib/hosting";

export default function LegacyDirectorWorkspaceScreenRedirect() {
  const { caseId, screenId } = useLocalSearchParams<{ caseId?: string | string[]; screenId?: string | string[] }>();
  const target = Array.isArray(screenId) ? screenId[0] : screenId;
  const requestedCaseId = Array.isArray(caseId) ? caseId[0] ?? "" : caseId ?? "";
  const query = requestedCaseId ? `?caseId=${encodeURIComponent(requestedCaseId)}` : "";

  return <Redirect href={staffPath(target ? `/admin/workspace/${target}${query}` : "/admin")} />;
}
